import React from "react";
import "../../styles/components/marketplace-shared.css";

const StatusPanel = ({
  eyebrow,
  title,
  description,
  tone = "info",
  icon,
  spinning = false,
  className = "",
}) => (
  <div className={`marketplace-status-panel marketplace-status-panel--${tone} ${className}`.trim()}>
    <div className="marketplace-status-panel__top">
      {eyebrow ? <span className="marketplace-status-panel__eyebrow">{eyebrow}</span> : <span />}
      {icon ? (
        <span className="marketplace-status-panel__icon">
          <i className={`fa ${icon}${spinning ? " fa-spin" : ""}`}></i>
        </span>
      ) : null}
    </div>
    <strong className="marketplace-status-panel__title">{title}</strong>
    {description ? <p className="marketplace-status-panel__description">{description}</p> : null}
  </div>
);

export default StatusPanel;


